const invoices = {
	buttons: {
		update_concept_invoices: "Entwurfsrechnungen aktualisieren",
	},
	overview: "Rechnungsübersicht",
	payment_status: {
		credit: "Credit",
		expired: "Abgelaufen",
		outstanding: "Offen",
		paid: "Bezahlt",
		partly_paid: "teilweise bezahlt",
	},
	status_invoices_update_success: "Entwurfsrechnungen erfolgreich aktualisiert",
	status_invoices_update_unknown:
		"Beim Aktualisieren von Rechnungsentwürfen ist etwas schief gelaufen",
	table: {
		amount: "Betrag",
		company_name: "Unternehmen",
		date: "Datum",
		debtor_code: "Schuldner-Code",
		id: "Rechnungsnummer",
		status: "Status",
	},
	title: "Rechnungen",
	update_invoices_dialog: {
		description: "Möchten Sie die Entwurfsrechnungen aktualisieren?",
		title: "Entwurfsrechnungen aktualisieren",
		update: "Aktualisieren",
	},
};

export default invoices;
